<!--
 * @Descripttion:购物车重构
 * @version:1.6.5
 * @Author: Jerry
 * @Date: 2021-08-16 08:54:56
 * @LastEditors: Jerry
 * @LastEditTime: 2022-07-05 09:23:58
-->
<template>
  <div :style="{ backgroundColor: (goodsList || []).length > 0 ? '#FFFFFF' : '#F3F5F7'}">
    <!-- 头部区域 -->
    <iHeader v-if="!isAlwaysBuysCom" />
    <iNav
      v-if="!isAlwaysBuysCom"
      :search="false"
      :car-btn="false"
      :phone="false"
      content
    >
      <div slot="content" class="flex-cont text-left" style="flex: 0 0 40%;">
        购物车
      </div>
      <div slot="content" class="flex-cont text-right" style="flex: 0 0 60%;">
        <van-image
          :src="require('../../assets/price.png')"
          width="116px"
          height="40px"
          @click.stop="price"
        />
      </div>
    </iNav>
    <!-- 头部区域结束 -->

    <!-- 购物车 -->
    <div
      v-if="goodsList.length || invalidGoods.length"
      :class="{ buycar: true, isAlwaysBuysCom: !!isAlwaysBuysCom }"
    >
      <!-- 商品列表 -->
      <!-- table title -->
      <div class="goods-title">
        <div class="checkedAll">
          <van-checkbox
            v-model="checkedAll"
            shape="square"
            checked-color="#0F6EE9"
            @click.stop="allCleckedClick"
          >全选</van-checkbox>
        </div>
        <div class="name">商品信息</div>
        <div class="price">单价</div>
        <div class="amount">数量</div>
        <div class="total">小计</div>
        <div v-if="!isAlwaysBuysCom" class="action">操作</div>
      </div>
      <!-- 活动大类头部区域 -->
      <div class="list-content">

        <template v-for="(item,idx) in goodsList">

          <!-- 按照活动组合 -->
          <template v-if="item.ActivityInfo.ActivityType==1">
            <!-- 商品折扣优惠信息展示 -->
            <div :key="idx+'itm'" class="itm">
              <!-- check -->
              <div class="check">
                <van-checkbox
                  v-model="item.ActivityInfo.checked"
                  shape="square"
                  checked-color="#0F6EE9"
                  @click.stop="handleClassChecked(item)"
                />
              </div>

              <div class="content">
                <div class="left-content">
                  <div class="type-title">{{ getConfigType(item.ActivityInfo.ActivityCode) }}</div>
                  <div class="type-cut">
                    <span v-if="[5,8,9].indexOf(item.ActivityInfo.ActivityCode) > -1 && item.ActivityInfo.TotalDiscount">已优惠<span class="cFF3939">{{ item.ActivityInfo.TotalDiscount }}</span>元</span>

                  </div>

                </div>
                <div v-if="!isAlwaysBuysCom && item.ActivityInfo.ActivityCode!==8" class="right-content" @click="goMoreCutPage(item.ActivityInfo.ActivityCode)">
                  更多{{ getConfigType(item.ActivityInfo.ActivityCode) }} >
                </div>
              </div>

            </div>
            <!-- 指定专区提示 -->
            <div :key="idx">
              <template v-for="(itm,i) in item.ActivityList">
                <div
                  v-if="itm.GoodsSkus.length"
                  :key="i+'s'+idx"
                  class="active-goods-card"
                  style="margin-bottom: 16px;"
                >
                  <!--       :class="{'no-margin-top': i === 0}" -->
                  <ActivityTag v-if="item.ActivityInfo.ActivityCode" :key="i+'tag'+idx" :activity-code="item.ActivityInfo.ActivityCode" :txt="itm.Activity.RuleText" :activity-data="itm.Activity" />
                  <BuyCarProductItem
                    v-for="(goodsItem,index) in itm.GoodsSkus"
                    :key="goodsItem.ProductSKUId"
                    :type-code="itm.Activity.ActivityTypeCode"
                    :activity="itm.Activity"
                    :has-margin-top="false"
                    :no-border="true"
                    :goods-skus-index="index"
                    :activity-list-index="i"
                    :list-index="idx"
                    :item="goodsItem"
                    :is-always-buys-com="isAlwaysBuysCom"
                    :is-zq-activity="true"
                    @itemCheckedChanged="checkedChange"
                    @cancelGoods="cancelGoods"
                    @onStepperChange="onStepperChange"
                  />
                  <!-- 赠品或者换购品 -->
                  <!-- 换购品&赠品item -->
                  <template
                    v-if="
                      (item.ActivityInfo.ActivityCode === 3 || item.ActivityInfo.ActivityCode === 4) &&
                        itm.Activity.ruleIndex > -1 &&
                        itm.Activity.Rules[itm.Activity.ruleIndex].ProductList.length
                    "
                  >

                    <BuyCarGiftList
                      v-for="giftInfo in itm.Activity.Rules[itm.Activity.ruleIndex].ProductList"
                      :key="giftInfo.SkuId"
                      :item="giftInfo"
                      :num="itm.Activity.num || 0"
                      :activity-code="item.ActivityInfo.ActivityCode"
                      @itemCheckedChanged="checkedChange"
                    />
                  </template>

                </div>
              </template>
            </div>
          </template>
          <!-- 普通非活动商品 -->
          <template v-else>
            <div :key="idx">
              <div class="invalid">
                <span style="font-size: 16px; font-weight: 500;">普通商品</span>
              </div>
              <div class="normal-goods-card active-goods-card">

                <div v-for="(mode, i) in item.ActivityList" :key="idx+'s'+i">

                  <BuyCarProductItem
                    v-for="(goodsItem, index) in mode.GoodsSkus"
                    :key="goodsItem.ProductSKUId"
                    :item="goodsItem"
                    :has-margin-top="true"
                    :goods-skus-index="index"
                    :activity-list-index="i"
                    :list-index="idx"
                    :is-always-buys-com="isAlwaysBuysCom"
                    :is-show-activity="true"
                    :is-zq-activity="mode.isNomal ? true : false"
                    :total-amount="totalAmount"
                    @itemCheckedChanged="checkedChange"
                    @cancelGoods="cancelGoods"
                    @finish="onRefresh"
                    @onStepperChange="onStepperChange"
                  />
                </div>
              </div>
            </div>
          </template>
        </template>
        <!-- 已失效商品 -->
        <div v-if="invalidGoods.length && !isAlwaysBuysCom">
          <div v-if="invalidGoods.length" class="invalid">
            <span style="font-size: 16px; font-weight: 500;">已失效商品</span>
            <span class="clear" @click="clearFailGoods">清除失效产品</span>
          </div>
          <BuyCarProductItem
            v-for="(item, i) in invalidGoods[0].ActivityList[0].GoodsSkus"
            :key="i + '1'"
            :item="item"
            is-invalid
            :is-zq-activity="true"
          />
        </div>
      </div>
    </div>
    <!-- /商品列表 -->

    <!-- 购物车提示 -->
    <div v-if="(goodsList || []).length > 0" class="block" />
    <transition name="van-fade">

      <div
        v-if="getPinkage"
        :class="{ status: true, isAlwaysBuysCom: isAlwaysBuysCom }"
      >
        <div class="content">
          再买{{
            (LogisticsFee.FreePostagePrice - totalAmount).toFixed(2)
          }}元就可以包邮啦～
          <div class="to-shop" @click.stop="goSearch()">
            <span>去凑单</span>
            <van-icon name="arrow" />
          </div>
        </div>
      </div>
    </transition>
    <!-- 结算栏 -->
    <div
      v-if="(goodsList || []).length > 0"
      :class="['submit', { 'show-shadow': !getPinkage }]"
    >
      <!-- 操作面板 -->
      <div
        :class="{ 'submit-c': true, 'isAlwaysBuysCom-submit': isAlwaysBuysCom }"
      >
        <van-checkbox
          v-model="checkedAll"
          shape="square"
          @click.stop="allCleckedClick"
        >全选</van-checkbox>
        <span
          v-if="!isAlwaysBuysCom"
          style="font-size: 14px;"
          class="submit-del"
          @click.stop="
            () => {
              cancelGoods(null)
            }
          "
        >
          删除选中商品
        </span>
        <div class="submit-totalsubmit-total">
          共 {{ totalAllNum }} 盒商品，已选择
          <span style="color: #FF3939;">{{ totalChooseNum }}</span>
          盒
        </div>
        <div class="submit-total">
          <div class="submit-sum">
            合计：
            <span>¥{{
              Math.abs(
                Math.round(totalAmount.toFixed(4) * 100) / 100
              ).toFixed(2)
            }}</span>
          </div>
          <div class="submit-maoli">
            毛利：¥{{ parseFloat(totalProfit).toFixed(2) }}
          </div>
        </div>
        <van-button
          class="submit-st"
          square
          color="#FF3939"
          :disabled="LogisticsFee.StartingPrice > totalAmount"
          @click.stop="onSettlement"
        >
          <div>
            {{
              LogisticsFee.StartingPrice > totalAmount
                ? '差' +
                  (LogisticsFee.StartingPrice - totalAmount).toFixed(2) +
                  '元起送'
                : '下单结算(' + totalChooseNum + ')'
            }}
          </div>
        </van-button>
      </div>
    </div>
    <!-- /结算栏 -->

    <!-- 空购物车 -->
    <div
      v-if="!goodsList.length && !invalidGoods.length"
      :class="{ emptycar: true, isAlwaysBuysCom: isAlwaysBuysCom }"
    >
      <img src="../../assets/buycar/empty.png">
      <div v-if="!isAlwaysBuysCom" class="ecar-txt">购物车空空如也~</div>
      <div v-else class="ecar-txt">暂无数据~</div>
      <van-button
        color="#0F6EEA"
        :to="{ path: '/' }"
        style="margin-top: 30px;"
      >去首页逛逛</van-button>
    </div>
    <iRightFixedBox v-if="!isAlwaysBuysCom" />
    <iFooter v-if="!isAlwaysBuysCom" />

  </div>
</template>

<script>
import iHeader from '@/components/Header'
import iFooter from '@/components/Footer'
import iNav from '@/components/Nav'
import iRightFixedBox from '@/components/RightFixedBox'
import BuyCarProductItem from './modules/BuyCarProductItem'

import BuyCarGiftList from './modules/BuyCarGiftList'

import ActivityTag from './modules/ActivityTag'
import { LinkTypeCode } from '@/dictionary/base.js'
import { BaseMixin } from '../../mixins/BaseMixin'
import { Dialog } from 'vant'
export default {
  name: 'Buycar',
  components: {
    iHeader,
    ActivityTag,
    BuyCarProductItem,
    BuyCarGiftList,
    iFooter,
    iNav,
    iRightFixedBox
  },
  mixins: [BaseMixin],
  props: {
    isAlwaysBuysCom: {
      // 是否为近期未采购页
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isEdit: false,
      typeList: [
        { val: 5, label: '特价' },
        { val: 6, label: '满减' },
        { val: 3, label: '满赠' },
        { val: 7, label: '满返' },
        { val: 4, label: '换购' },
        { val: 8, label: '秒杀' },
        { val: 9, label: '效期' }
      ],

      LinkTypeCode,
      goodsList: [], // 购物车商品
      checkedAll: false, // 是否全选
      invalidGoods: [], // 失效商品

      // list
      allGoodsList: [], // 所有商品

      rebateCouponsList: [], // 返券列表
      ordinaryGoodsPremiumList: [], // 平台满赠活动列表

      showInputNum: false,
      valInputNum: 0,
      valItem: {},
      /**
       * 数据加载的相关状态
       */
      stepChanging: false,
      formData: {
        page: 0,
        pagesize: 100
      },

      totalChooseNum: 0, // 已选择商品数
      totalAllNum: 0, // 购物车有效商品总数
      totalAmount: 0, // 已选中商品总价
      totalProfit: 0, // 总毛利

      LogisticsFee: {},

      PromotionList: {
        Reduction: [], // 买减，满减
        Present: [], // 买赠，满赠
        Coupons: [] // 返券
      },
      url: {
        // 常购清单
        getPurchasedList: '/api_order/ShoppingCarts/GetPurchasedGoods',
        // 获取购物车商品列表
        cardGoodsList: '/api_order/ShoppingCarts/ShoppingCartsList',
        // 满赠信息
        activityPremiumZon:
          '/api_order/ShoppingCarts/GetShoppingCartActivityList',
        // 商品步长
        addOrUpdateCart: '/api_order/ShoppingCarts/AddOrUpdateCart',
        // 移除购物车信息
        delete: '/api_order/ShoppingCarts/Delete',
        // 购物车返券查询
        rebateCouponsList: '/api_coupon/Coupon/ShoppingCartsCoupons',
        // 获取物流费用的接口
        logisticsFee: '/api_order/Orders/LogisticsTemplate',
        // 结算创建订单
        confirmCarOrder: '/api_order/Orders/ConfirmOrderV2'
      },
      // 赠品列表
      GiftInfo: {
        OverScopeList: [],
        GiftList: []
      },
      // 满赠-按照订单
      GroupByOrder: false,
      // 满赠-按照订单列表
      GroupByOrderList: [],
      // 按订单-显示所有阶梯
      AllConfig: null,
      // 多商品满赠配置集合
      MoreActivGift: [],
      // 多商品模块赠品集合
      GroupActiveGift: [],
      // 满赠-类型为每满的倍数
      Multiple: 0,
      // 安商品 满赠-类型为多商品
      MultipleMore: 0,
      // 安订单 满赠-类型为每满的倍数
      GroupByOrderMultiple: 0,
      // 提交封装满赠活动数据
      SubmitActivitys: [],
      ModelList: [],
      // 购物中所有商品赠品（判断） 集合
      GifthasSendList: [],
      // 按订单可选商品数量
      GroupByOrderChooseGiftNum: 0,
      // 按订单判断是否选送选完
      gifthasSend: {},
      GroupByOrderFianll: false,
      // 判断是否有赠品
      IsHasGift: false
    }
  },
  computed: {
    // 获取是否满足包邮
    getPinkage() {
      const { LogisticsFee, totalAmount } = this
      if (
        LogisticsFee.StartingPrice <= totalAmount &&
        LogisticsFee.FreePostagePrice > totalAmount
      ) {
        return true
      }
      return false
    },
    // 过滤失效商品
    getFailGoodsList() {
      const { goodsList } = this
      // 降维获取所有购物车商品
      const allCarGoodsList = goodsList.map((item) => item.GoodsSkus).flat()
      const filterFailList = allCarGoodsList.filter(
        (item) => !item.IsPutaway || item.Stock <= 0
      )
      return filterFailList
    }

  },
  watch: {
    goodsList: {
      // 商品数据源变动时，重新计算价格相关
      // 商品数据源变动时，判断全选与反选的关系
      handler(val) {
        this.calcMoney()
        if (!val.length) {
          this.checkedAll = false
        }
      },
      deep: true,
      immediate: true
    }
  },
  created() {
    const cusInfo = this.$auth.getCustomerOtherInfo()
    if (!cusInfo || !cusInfo.IsOrder) {
      this.$toast({
        position: 'bottom',
        message:
          cusInfo && cusInfo.NoOrderMsg ? cusInfo.NoOrderMsg : '暂时不能下单'
      })
      this.$router.push(LinkTypeCode.Home)
      return
    }
  },
  mounted() {
    this.onRefresh()
  },
  methods: {
    /**
     * ajax部分
     */
    // 初始加载
    async onRefresh() {
      this.init()
      //  this.$hys.getCartCount(this, true)
      this.formData.page = 0 // 初始请求分页
      await this.onLoad()
    },
    async init() {
      Object.assign(this.$data, this.$options.data.call(this))

      const { isAlwaysBuysCom = false } = this
      // 获取物流满包邮信息
      this.getAction(this.url.logisticsFee).then((res) => {
        this.LogisticsFee = res.LogisticsTemplate || {}
      })
      if (!isAlwaysBuysCom) {
        // 购物车返券查询
        this.getAction(this.url.rebateCouponsList).then((res) => {
          if (!res.IsSuccess) {
            return
          }
          this.rebateCouponsList = res.Data
        })
      }
      this.SubmitActivitys = []
    },
    // 加载商品数据
    async onLoad() {
      this.formData.page = this.formData.page + 1
      await this.getBuyCarList()
    },
    // 同步数据
    syncCurrentSourceData(idx, index, i, key, value) {
      this.$set(this.goodsList[idx].ActivityList[index].GoodsSkus[i], key, value)
    },
    // 购物车移除商品
    async cancelGoods(itemId) {
      try {
        let cancelArr = []
        if (itemId) {
          if (Array.isArray(itemId)) {
            cancelArr = [...itemId]
          } else {
            // 侧滑删除
            cancelArr.push(itemId)
          }
        } else {
          // 编辑删除
          cancelArr =
            this.getAllChooseGoods('all').map((item) => item.ShoppingCartId) ||
            []
        }
        if (cancelArr.length == 0) {
          this.$toast({
            position: 'bottom',
            message: '请选择需要删除的商品'
          })
          return
        }
        this.$hys.openLoading()
        const res = await this.postAction(this.url.delete, cancelArr.filter(val => val))
        this.$hys.clearLoading()
        if (!res.IsSuccess) {
          this.$toast({ position: 'bottom', message: res.Msg })
          return
        }
        this.$nextTick((oo) => {
          this.onRefresh()
        })
        this.$bus.$emit('rightBuycarChanged', res.Data.ProductCount, true)
        this.$toast({ position: 'bottom', message: '删除成功' })

        this.checkedAll = false
      } catch (error) {
        this.$hys.clearLoading()
        console.log(error)
      }
    },
    // 加载购物车数据
    async getBuyCarList() {
      const { isAlwaysBuysCom = false } = this
      const { cardGoodsList, getPurchasedList } = this.url
      // 加载状态
      this.$hys.openLoading()
      const res = await this.getAction(
        `${isAlwaysBuysCom ? getPurchasedList : cardGoodsList}`
      )
      this.$hys.clearLoading()
      if (!res.IsSuccess) {
        // 数据异常，停止继续加载数据
        this.$toast({ position: 'bottom', message: res.Msg })
        return
      }
      if (this.formData.page == 1) {
        this.goodsList = []
      }
      // 数据处理
      this.filterInvalidGoods(res.Data || [])
    },
    // 凑单跳转
    goSearch() {
      this.$router.push({
        name: LinkTypeCode.SearchPage,
        query: {}
      })
    },
    // 大类全选与反选
    handleClassChecked(activity) {
      const { ActivityInfo, ActivityList } = activity
      const status = ActivityInfo.checked
      ActivityList.forEach((item) => {
        item.GoodsSkus.forEach((goods) => {
          goods.checked = status
        })
        // 设置换购品选中状态
        if (ActivityInfo.ActivityCode === 4) {
          setTimeout(() => {
            if (item.Activity.ruleIndex > -1) {
              item.Activity.Rules[item.Activity.ruleIndex].ProductList.forEach(gift => {
                if (gift.Stock && !gift.IsOutBusinessScope && !gift.IsControll && gift.IsPutaway === 1) { gift.checked = status }
              })
            }
          }, 30)
        }
      })
      this.checkedChange()
    },
    // 全选与反选
    allCleckedClick() {
      const { checkedAll } = this
      if (checkedAll) {
        // 全选
        this.setAllGoodsItemCheckStatus(true)
      } else {
        // 取消全选
        this.setAllGoodsItemCheckStatus(false)
      }
    },
    // 设置所有商品选中状态
    setAllGoodsItemCheckStatus(checkedStatus) {
      this.goodsList.forEach((data, i) => {
        this.$set(this.goodsList[i].ActivityInfo, 'checked', checkedStatus)
        data.ActivityList.forEach((activity, j) => {
          // 非编辑状态下，改变换购商品选中状态
          if (!this.isEdit && data.ActivityInfo.ActivityCode === 4) {
            setTimeout(() => {
              if (activity.Activity.ruleIndex > -1) {
                activity.Activity.Rules[activity.Activity.ruleIndex].ProductList.forEach((exchange, l) => {
                  // 库存不足、超出经营范围、被控销、已下架的换购品不能选择
                  if (exchange.Stock && !exchange.IsOutBusinessScope && !exchange.IsControll && exchange.IsPutaway === 1) {
                    const { ruleIndex } = activity.Activity
                    this.$set(this.goodsList[i].ActivityList[j].Activity.Rules[ruleIndex].ProductList[l], 'checked', checkedStatus)
                  }
                })
              }
            }, 30)
          }
          activity.GoodsSkus.forEach((item, k) => {
            if (this.isEdit) {
              // 编辑状态下，改变所有商品状态
              this.$set(this.goodsList[i].ActivityList[j].GoodsSkus[k], 'checked', checkedStatus)
            } else if (data.ActivityInfo.ActivityType !== 3) {
              // 非编辑状态下，排除失效商品
              this.$set(this.goodsList[i].ActivityList[j].GoodsSkus[k], 'checked', checkedStatus)
            } else {
              // 失效商品不可选
              this.$set(this.goodsList[i].ActivityList[j].GoodsSkus[k], 'checked', null)
            }
          })
        })
      })
    },
    // 过滤数据
    filterInvalidGoods(data) {
      this.goodsList = data.filter(val => val.ActivityInfo.ActivityType !== 3)
      // 第一次设置所有商品为选中
      this.setAllGoodsItemCheckStatus(true)
      // this.goodsList .map(val => ({ ...val, checked: val.ActivityInfo.ActivityType === 1, ActivityList: val.ActivityList.map((v) => ({ ...v, GoodsSkus: v.GoodsSkus.map(pv => ({ ...pv, checked: true })) })) }))

      this.invalidGoods = data.filter(val => val.ActivityInfo.ActivityType === 3)
      this.checkedChange()
    },
    checkedChange() {
      // 判断是否全选
      if (this.getAllGoodsCheckedStatus()) {
        this.checkedAll = false
        return
      }
      this.checkedAll = true
    },
    getAllGoodsCheckedStatus() {
      let count = 0
      this.goodsList.forEach((goods, index) => {
        goods.ActivityInfo.Count = 0
        goods.ActivityList.forEach((activity) => {
          // 非编辑状态下，检查换购商品选中状态
          if (!this.isEdit && goods.ActivityInfo.ActivityCode === 4 && activity.Activity.ruleIndex > -1 && activity.Activity.Rules[activity.Activity.ruleIndex].ProductList.length) {
            activity.Activity.Rules[activity.Activity.ruleIndex].ProductList.forEach(exchange => {
              if (exchange.Stock && !exchange.IsOutBusinessScope && !exchange.IsControll && exchange.IsPutaway === 1 && !exchange.checked) {
                count++
                goods.ActivityInfo.Count++
              }
            })
          }
          activity.GoodsSkus.forEach((good) => {
            if (!this.isEdit) {
              if (goods.ActivityInfo.ActivityType !== 3 && !good.checked) {
                count++
                goods.ActivityInfo.Count++
              }
            } else {
              if (!good.checked) {
                count++
                goods.ActivityInfo.Count++
              }
            }
          })
        })
        this.$set(this.goodsList[index].ActivityInfo, 'checked', !goods.ActivityInfo.Count)
      })
      return count
    },
    // 获取对应字典内容
    getConfigType(data) {
      const dataArr = this.typeList.filter(v => v.val === data)
      return dataArr.length ? dataArr[0].label : ''
    },
    // 查看更多
    goMoreCutPage(code) {
      if (code == 8) {
        this.$router.push({
          name: LinkTypeCode.ActivitySeckillView,
          params: { id: this.$route.query.goodsId }
        })
      } else if (code == 3 || code == 4) {
        this.$router.push({
          name: LinkTypeCode.ActivityGiftView,
          params: { }
        })
      } else {
        this.$router.push({
          name: LinkTypeCode.ActivityView
        })
      }
    },
    // 清空失效商品
    clearFailGoods() {
      const { invalidGoods } = this
      let allFailIds = []

      invalidGoods.forEach(val => {
        val.ActivityList.forEach(value => {
          allFailIds = allFailIds.concat(value.GoodsSkus.map(v => v.ShoppingCartId))
        })
      })
      this.cancelGoods(allFailIds)
    },
    // 获取选中商品的集合-默认只返回有效商品的集合，编辑时删除返回所有集合
    getAllChooseGoods(type = '') {
      // 有效商品集合
      let validList = []
      this.goodsList.forEach((val, idx) => {
        val.ActivityList.forEach(v => {
          validList = [...validList, ...v.GoodsSkus.filter((item) => item.checked)]
        })
      })
      if (type === 'all') {
        // 所有时返回有效和失效商品的id集合
        // 失效商品id集合
        let failList = []
        this.invalidGoods.forEach((val, idx) => {
          val.ActivityList.forEach(v => {
            failList = [...failList, v.GoodsSkus.filter((item) => item.checked)]
          })
        })
        return [...validList, ...failList]
      } else {
        return validList
      }
    },
    // 计算选中商品总价、毛利、总数相关
    calcMoney() {
      let totalAmount = 0 // 选中商品总价
      let totalProfit = 0 // 总毛利
      let totalNum = 0 // 选中商品总数
      let totalAllNum = 0 // 有效商品总盒数
      let totalOriginAmount = 0 // 选中商品原价总价-用来计算是否满足包邮条件
      this.goodsList.forEach((data, i) => {
        // 计算特价、效期、秒杀活动小类优惠力度
        if ([5, 8, 9].indexOf(data.ActivityInfo.ActivityCode) > -1) {
          let totalCount = 0
          let isItemChecked = false
          data.ActivityList.forEach(activity => {
            // 筛出选中的商品
            const goods = activity.GoodsSkus.filter(item => item.checked)
            // 优惠金额
            let discount = 0
            if (goods.length) {
              isItemChecked = true
              goods.forEach(item => {
                discount = discount.add(item.Price.sub(item.PriceLimit).mul(item.Count))
                totalProfit += item.RetailPrice.sub(item.ActivityPrice ?? item.PriceLimit).mul(item.Count)
                totalNum += item.Count
                totalOriginAmount += item.Count.mul(item.PriceLimit)
                totalAmount += (item.ActivityPrice ?? item.PriceLimit).mul(item.Count)
              })
            }
            activity.Activity.Discount = discount
            activity.Activity.RuleText = goods.length && `${activity.Activity.ActivityName}，已优惠<span style="color:#FF3939;">${discount}</span>元`
            totalCount = totalCount.add(discount)
          })
          data.ActivityInfo.TotalDiscount = totalCount
          data.ActivityInfo.IsItemChecked = isItemChecked
        } else if (data.ActivityInfo.ActivityType !== 3) { // 排除失效商品
          data.ActivityList.forEach((activity, j) => {
            // 换购活动，计算选中的换购品
            if (data.ActivityInfo.ActivityCode === 4) {
              const exchangeObj = this.calcExchange(activity)
              totalProfit += exchangeObj.totalProfit
              totalNum += exchangeObj.totalNum
              totalOriginAmount += exchangeObj.totalOriginAmount
              totalAmount += exchangeObj.totalAmount
            }
            // 满赠活动，计算满赠门槛
            if (data.ActivityInfo.ActivityCode === 3) {
              this.calcFullSend(activity)
            }
            // 满返活动，计算满返门槛
            if (data.ActivityInfo.ActivityCode === 7) {
              this.calcCoupon(activity)
            }
            // 满减活动，计算满减门槛

            activity.GoodsSkus.forEach((item, k) => {
              if (item.checked) {
                totalProfit = totalProfit.add(item.RetailPrice.sub(item.ActivityPrice ?? item.PriceLimit).mul(item.Count))
                totalNum = totalNum.add(item.Count)
                totalOriginAmount = totalOriginAmount.add(item.Count.mul(item.PriceLimit))
                totalAmount = totalAmount.add((item.ActivityPrice ?? item.PriceLimit).mul(item.Count))
              }
            })
            // 满减活动，计算满减门槛
            if (data.ActivityInfo.ActivityCode === 6) {
              totalAmount = totalAmount.sub(this.calcReduce(activity))
            }
          })
        }
      })

      this.totalAmount = totalAmount // 选中商品总价
      this.totalProfit = totalProfit // 总毛利
      this.totalChooseNum = totalNum // 选中商品总数
      this.totalOriginAmout = totalOriginAmount // 选中商品原价总价
      // 有效商品集合
      const validList = this.goodsList
        .map((item) => item.ActivityList.map(v => v.GoodsSkus)).flat(2).filter(val => val.Stock > 0 && !val.IsSoldOut)
      validList.forEach((item) => {
        totalAllNum += item.Count
      })
      this.totalAllNum = totalAllNum
      this.$forceUpdate()
    },
    // 换购品计算,传入小类对象
    calcExchange(activity) {
      const goods = activity.GoodsSkus.filter(item => item.checked)
      const obj = {
        totalProfit: 0,
        totalNum: 0,
        totalOriginAmount: 0,
        totalAmount: 0
      }
      let limit = 0 // 总金额 | 总数量
      let unit = '' // 单位
      let ruleIndex = -1 // 当前满足门槛的index
      let exchangeList = [] // 换购品list
      let ruleText = '' // 活动门槛信息
      let nowRule = [] // 当前满足的规则
      let nextRule = [] // 下一级规则
      if (!goods.length) {
        // 赋值门槛规则信息
        activity.Activity.RuleText = ruleText
        activity.Activity.ruleIndex = ruleIndex
        return obj
      }
      goods.forEach(item => {
        if (activity.Activity.ActivityTypeCode === 1) {
          // 金额换购
          limit += (item.ActivityPrice ?? item.PriceLimit).mul(item.Count)
          unit = '元'
        } else if (activity.Activity.ActivityTypeCode === 2) {
          // 数量换购
          limit += item.Count
          unit = '个'
        }
      })
      // 根据换购类型，遍历规则阶梯，拿该小类下已选商品的金额/数量去比对门槛条件
      activity.Activity.Rules.forEach((rule, index) => {
        if (rule.Limit <= limit) {
          exchangeList = rule.ProductList
          ruleIndex = index
        }
      })
      // 拼接规则
      if (ruleIndex > -1) {
        // 已满足条件
        nowRule = activity.Activity.Rules[ruleIndex]
        ruleText = `已满${nowRule.Limit}${unit}可换购【${nowRule.ProductList[0].SkuName}】*${nowRule.ProductList[0].Count}${nowRule.ProductList.length > 1 ? '等' : ''}`
        if (activity.Activity.Rules.length > ruleIndex + 1) {
          nextRule = activity.Activity.Rules[ruleIndex + 1]
          ruleText += `；加购<span style="color:#FF3939;">${nextRule.Limit.sub(limit)}</span>${unit}，可换购【${nextRule.ProductList[0].SkuName}】*${nextRule.ProductList[0].Count}${nextRule.ProductList.length > 1 ? '等' : ''}`
        }
      } else {
        nowRule = activity.Activity.Rules[0]
        ruleText = `满${nowRule.Limit}${unit}可换购；加购<span style="color:#FF3939;">${nowRule.Limit.sub(limit)}</span>${unit}，可换购【${nowRule.ProductList[0].SkuName}】*${nowRule.ProductList[0].Count}${nowRule.ProductList.length > 1 ? '等' : ''}`
      }
      // 赋值门槛规则信息
      activity.Activity.RuleText = ruleText
      activity.Activity.ruleIndex = ruleIndex

      // 计算当前门槛下已选中的换购品总金额、总毛利、总数量等
      exchangeList.forEach(ex => {
        if (ex.checked) {
          obj.totalProfit += ex.RetailPrice.sub(ex.PriceLimit).mul(ex.Count)
          obj.totalNum += ex.Count
          obj.totalOriginAmount += ex.PriceLimit.mul(ex.Count)
          obj.totalAmount += ex.PriceLimit.mul(ex.Count)
        }
      })

      return obj
    },
    // 计算满赠、每满赠门槛
    calcFullSend(activity) {
      const goods = activity.GoodsSkus.filter(item => item.checked)
      const { ActivityTypeCode } = activity.Activity
      let sendList = [] // 赠品列表
      let nowRule = {} // 当前满足的规则
      let nextRule = {} // 下一级规则
      let remainder = 0 // 余数
      let num = 0 // 已满足多少次（每满时用)
      let count = 0 // 总数量
      let limit = 0 // 总金额
      let ruleText = '' // 门槛规则信息
      let ruleIndex = -1 // 当前满足的规则index
      if (!goods.length) {
        // 赋值门槛规则信息
        activity.Activity.RuleText = ruleText
        activity.Activity.ruleIndex = ruleIndex
        return
      }
      goods.forEach(item => {
        limit += (item.ActivityPrice ?? item.PriceLimit).mul(item.Count)
        count += item.Count
      })
      // 金额每满赠
      if (ActivityTypeCode === 513) {
        const { Limit, ProductList } = activity.Activity.Rules[0]
        if (limit >= Limit) {
          // 已满足条件
          ruleIndex = 0
          remainder = limit % Limit // 余数
          num = parseInt(limit.div(Limit))// 共满足了多少次
          ruleText = `已满${Limit.mul(num)}元可获赠【${ProductList[0].SkuName}】*${ProductList[0].Count.mul(num)}${ProductList.length > 1 ? '等' : ''}，加购<span style="color:#FF3939;">${Limit.sub(remainder)}</span>元可获赠【${ProductList[0].SkuName}】*${ProductList[0].Count}${ProductList.length > 1 ? '等' : ''}`
        } else {
          // 未满足条件
          remainder = Limit.sub(limit)
          ruleText = `每满${Limit}元可得赠品，加购<span style="color:#FF3939;">${remainder}</span>元可获赠【${ProductList[0].SkuName}】*${ProductList[0].Count}${ProductList.length > 1 ? '等' : ''}`
        }
      }
      // 数量每满赠
      if (ActivityTypeCode === 514) {
        const { Limit, ProductList } = activity.Activity.Rules[0]
        if (count >= Limit) {
          // 已满足条件
          ruleIndex = 0
          remainder = count % Limit // 余数
          num = parseInt(count.div(Limit)) // 共满足了多少次
          ruleText = `已满${Limit.mul(num)}个可获赠【${ProductList[0].SkuName}】*${ProductList[0].Count.mul(num)}${ProductList.length > 1 ? '等' : ''}，加购<span style="color:#FF3939;">${Limit.sub(remainder)}</span>个可获赠【${ProductList[0].SkuName}】*${ProductList[0].Count}${ProductList.length > 1 ? '等' : ''}`
        } else {
          // 未满足条件
          remainder = Limit.sub(count)
          ruleText = `每满${Limit}个可得赠品，加购<span style="color:#FF3939;">${remainder}</span>个可获赠【${ProductList[0].SkuName}】*${ProductList[0].Count}${ProductList.length > 1 ? '等' : ''}`
        }
      }
      // 金额满赠
      if (ActivityTypeCode === 257) {
        activity.Activity.Rules.forEach((rule, index) => {
          if (rule.Limit <= limit) {
            ruleIndex = index
          }
        })
        if (ruleIndex > -1) {
          // 已满足条件
          nowRule = activity.Activity.Rules[ruleIndex] // 当前满足的规则
          sendList = nowRule.ProductList // 当前规则的赠品list
          ruleText = `已满${nowRule.Limit}元可获赠【${sendList[0].SkuName}】*${sendList[0].Count}${sendList.length > 1 ? '等' : ''}`
          if (activity.Activity.Rules.length > ruleIndex + 1) {
            nextRule = activity.Activity.Rules[ruleIndex + 1] // 下一级规则
            remainder = nextRule.Limit.sub(limit) // 与下一级规则的差额
            ruleText += `；加购<span style="color:#FF3939;">${remainder}</span>元可获赠【${nextRule.ProductList[0].SkuName}】*${nextRule.ProductList[0].Count}${nextRule.ProductList.length > 1 ? '等' : ''}`
          }
        } else {
          // 未满足条件
          nowRule = activity.Activity.Rules[0]
          sendList = nowRule.ProductList
          remainder = nowRule.Limit.sub(limit)
          ruleText = `满${nowRule.Limit}元可得赠品，加购<span style="color:#FF3939;">${remainder}</span>元可获赠【${sendList[0].SkuName}】*${sendList[0].Count}${sendList.length > 1 ? '等' : ''}`
        }
      }
      // 数量满赠
      if (ActivityTypeCode === 258) {
        activity.Activity.Rules.forEach((rule, index) => {
          if (rule.Limit <= count) {
            ruleIndex = index
          }
        })
        if (ruleIndex > -1) {
          // 已满足条件
          nowRule = activity.Activity.Rules[ruleIndex] // 当前满足的规则
          sendList = nowRule.ProductList // 当前规则的赠品list
          ruleText = `已满${nowRule.Limit}个可获赠【${sendList[0].SkuName}】*${sendList[0].Count}${sendList.length > 1 ? '等' : ''}`
          if (activity.Activity.Rules.length > ruleIndex + 1) {
            nextRule = activity.Activity.Rules[ruleIndex + 1] // 下一级规则
            remainder = nextRule.Limit.sub(count) // 与下一级规则的差额
            ruleText += `；加购<span style="color:#FF3939;">${remainder}</span>个可获赠【${nextRule.ProductList[0].SkuName}】*${nextRule.ProductList[0].Count}${nextRule.ProductList.length > 1 ? '等' : ''}`
          }
        } else {
          // 未满足条件
          nowRule = activity.Activity.Rules[0]
          sendList = nowRule.ProductList
          remainder = nowRule.Limit.sub(count)
          ruleText = `满${nowRule.Limit}个可得赠品，加购<span style="color:#FF3939;">${remainder}</span>个可获赠【${sendList[0].SkuName}】*${sendList[0].Count}${sendList.length > 1 ? '等' : ''}`
        }
      }
      // 赋值门槛规则信息
      activity.Activity.RuleText = ruleText
      activity.Activity.ruleIndex = ruleIndex
      activity.Activity.num = num
    },
    // 计算满返、每满返门槛
    calcCoupon(activity) {
      const goods = activity.GoodsSkus.filter(item => item.checked)
      const { ActivityTypeCode } = activity.Activity
      let couponList = [] // 优惠券列表
      let nowRule = {} // 当前满足的规则
      let nextRule = {} // 下一级规则
      let remainder = 0 // 余数
      let num = 0 // 已满足多少次（每满时用)
      let limit = 0 // 总金额
      let ruleText = '' // 门槛规则信息
      let ruleIndex = -1 // 当前满足的规则index
      if (!goods.length) {
        // 赋值门槛规则信息
        activity.Activity.RuleText = ruleText
        return
      }
      goods.forEach(item => {
        limit += (item.ActivityPrice ?? item.PriceLimit).mul(item.Count)
      })
      // 满返
      if (ActivityTypeCode === 4) {
        activity.Activity.Rules.forEach((rule, index) => {
          if (rule.Limit <= limit) {
            ruleIndex = index
          }
        })
        if (ruleIndex > -1) {
          // 已满足条件
          nowRule = activity.Activity.Rules[ruleIndex] // 当前满足的规则
          couponList = nowRule.CouponList // 当前规则的优惠券list
          ruleText = `已满${nowRule.Limit}元可返【${couponList[0].CouponMoney}优惠券】*${couponList[0].CouponCount}张${couponList.length > 1 ? '等' : ''}`
          if (activity.Activity.Rules.length > ruleIndex + 1) {
            nextRule = activity.Activity.Rules[ruleIndex + 1] // 下一级规则
            remainder = nextRule.Limit.sub(limit) // 与下一级规则的差额
            ruleText += `；加购<span style="color:#FF3939;">${remainder}</span>元可返【${nextRule.CouponList[0].CouponMoney}优惠券】*${nextRule.CouponList[0].CouponCount}张${nextRule.CouponList.length > 1 ? '等' : ''}`
          }
        } else {
          // 未满足条件
          nowRule = activity.Activity.Rules[0]
          couponList = nowRule.CouponList
          remainder = nowRule.Limit.sub(limit)
          ruleText = `满${nowRule.Limit}元可返券，加购<span style="color:#FF3939;">${remainder}</span>元可返【${couponList[0].CouponMoney}优惠券】*${couponList[0].CouponCount}张${couponList.length > 1 ? '等' : ''}`
        }
      }
      // 每满返
      if (ActivityTypeCode === 8) {
        const { Limit, CouponList } = activity.Activity.Rules[0]
        if (limit >= Limit) {
          ruleIndex = 0
          // 已满足条件
          remainder = limit % Limit // 余数
          num = parseInt(limit.div(Limit)) // 共满足了多少次
          ruleText = `已满${Limit.mul(num)}元可返【${CouponList[0].CouponMoney}优惠券】*${CouponList[0].CouponCount.mul(num)}张${CouponList.length > 1 ? '等' : ''}，加购<span style="color:#FF3939;">${Limit.sub(remainder)}</span>元可返【${CouponList[0].CouponMoney}优惠券】*${CouponList[0].CouponCount}张${CouponList.length > 1 ? '等' : ''}`
        } else {
          // 未满足条件
          remainder = Limit.sub(limit)
          ruleText = `每满${Limit}元可返券，加购<span style="color:#FF3939;">${remainder}</span>元可返【${CouponList[0].CouponMoney}优惠券】*${CouponList[0].CouponCount}张${CouponList.length > 1 ? '等' : ''}`
        }
      }
      // 赋值门槛规则信息
      activity.Activity.RuleText = ruleText
      activity.Activity.ruleIndex = ruleIndex
    },
    // 计算满减、每满减门槛
    calcReduce(activity) {
      const goods = activity.GoodsSkus.filter(item => item.checked)
      const { ActivityTypeCode } = activity.Activity
      let nowRule = {} // 当前满足的规则
      let nextRule = {} // 下一级规则
      let remainder = 0 // 余数
      let num = 0 // 已满足多少次（每满时用)
      let limit = 0 // 总金额
      let ruleText = '' // 门槛规则信息
      let ruleIndex = -1 // 当前满足的规则index
      let discount = 0 // 总减金额
      if (!goods.length) {
        // 赋值门槛规则信息
        activity.Activity.RuleText = ruleText
        return discount
      }
      goods.forEach(item => {
        limit += (item.ActivityPrice ?? item.PriceLimit).mul(item.Count)
      })
      // 满减
      if (ActivityTypeCode === 16) {
        activity.Activity.Rules.forEach((rule, index) => {
          if (rule.Limit <= limit) {
            ruleIndex = index
          }
        })
        if (ruleIndex > -1) {
          // 已满足条件
          nowRule = activity.Activity.Rules[ruleIndex]

          if (nowRule.DiscountType === 1) {
            // 减免
            discount = nowRule.Reduce // 需减金额
          } else if (nowRule.DiscountType === 2) {
            // 折扣
            discount = limit.mul(1 - nowRule.Reduce.div(10)) // 需减金额
          }
          ruleText = `已满${nowRule.Limit}元，已减${discount}元`
          if (activity.Activity.Rules.length > ruleIndex + 1) {
            nextRule = activity.Activity.Rules[ruleIndex + 1] // 下一级规则
            remainder = nextRule.Limit.sub(limit) // 与下一级规则的差额
            ruleText += `；加购<span style="color:#FF3939;">${remainder}</span>元，可${nextRule.DiscountType === 1 ? '减' : '打'}<span style="color:#FF3939;">${nextRule.Reduce}</span>${nextRule.DiscountType === 1 ? '元' : '折'}`
          }
        } else {
          // 未满足条件
          nowRule = activity.Activity.Rules[0]
          remainder = nowRule.Limit.sub(limit) // 差额
          ruleText = `满${nowRule.Limit}元可${nowRule.DiscountType === 1 ? '减' : '打折'}，加购<span style="color:#FF3939;">${remainder}</span>元可${nowRule.DiscountType === 1 ? '减' : '打'}${nowRule.Reduce}${nowRule.DiscountType === 1 ? '元' : '折'}`
        }
      }
      // 每满减
      if (ActivityTypeCode === 32) {
        const { Limit, Reduce, DiscountType } = activity.Activity.Rules[0]
        ruleText = `每满${Limit}元，${DiscountType === 1 ? '减' : '打'}${Reduce}${DiscountType === 1 ? '元' : '折'}`
        num = parseInt(limit.div(Limit)) // 共满足了多少次
        if (limit >= Limit && DiscountType === 1) {
          // 减免
          discount = Reduce.mul(num) // 需减金额
          ruleIndex = 0
        } else if (limit >= Limit && DiscountType === 2) {
          // 折扣
          discount = Limit.mul(1 - Reduce.div(10)).mul(num)
          ruleIndex = 0
        }
      }
      // 赋值门槛规则信息
      activity.Activity.RuleText = ruleText
      activity.Activity.ruleIndex = ruleIndex
      return discount
    },
    // 步长加减购-
    async onStepperChange(Count, changeGoodsItem) {
      // console.log(233)

      if (Count === changeGoodsItem.Count) {
        return
      }
      const toastLoading = this.$toast.loading({
        message: '',
        duration: 0,
        forbidClick: true
      })
      try {
        const { isAlwaysBuysCom = false } = this

        this.stepChanging = true
        const { GoodSkuId, ActivityId } = changeGoodsItem
        // 步长请求
        const formData = {
          ProductSKUId: GoodSkuId,
          Count
        }
        if (ActivityId && ActivityId != '00000000-0000-0000-0000-000000000000')formData.ActivityId = ActivityId
        const res = await this.postAction(this.url.addOrUpdateCart, formData)
        if (!res.IsSuccess) {
          this.$toast({
            position: 'bottom',
            message: res.Msg
          })
          this.stepChanging = false
          return
        }
        // 判断是否可以加购
        if (res.Data.IsLimitPerOrder) {
          this.stepChanging = false
          return false
        }
        // 返回Amount为0，表示该商品没有库存已被删除，刷新页面数据
        if (!res.Data.Amount > 0) {
          location.reload()
        }
        // 判断是否超限
        if (res.Data.IsLimit === null || !res.Data.IsLimit) {
          if (res.Data.Amount != Count) {
            this.$confirm('步长为' + changeGoodsItem.StepLengthNumber)
          }
          changeGoodsItem.Count = res.Data.Amount
        } else {
          this.$toast({
            position: 'bottom',
            message:
              '单笔订单限购（' +
              res.Data.LimitPerOrder +
              '）盒'
          })
          this.stepChanging = false
        }

        if (res.Data.CountData) {
          if (!isAlwaysBuysCom) {
            // 购物车页时
            this.$bus.$emit(
              'rightBuycarChanged',
              res.Data.CountData.ProductCount,
              true
            )
          }

          this.stepChanging = false
          toastLoading.clear()
          if (changeGoodsItem.ActivityCode === 4) {
            this.goodsList.forEach((data, i) => {
              data.ActivityList.forEach((activity, j) => {
                if (data.ActivityInfo.ActivityCode === 4) {
                  setTimeout(() => {
                    if (activity.Activity.ruleIndex > -1) {
                      activity.Activity.Rules[activity.Activity.ruleIndex].ProductList.forEach((exchange, l) => {
                      // 库存不足、超出经营范围、被控销、已下架的换购品不能选择
                        if (exchange.Stock && !exchange.IsOutBusinessScope && !exchange.IsControll && exchange.IsPutaway === 1) {
                          const { ruleIndex } = activity.Activity
                          this.$set(this.goodsList[i].ActivityList[j].Activity.Rules[ruleIndex].ProductList[l], 'checked', true)
                        }
                      })
                    }
                  }, 30)
                }
              })
            })
          }
        }
        toastLoading.clear()
        // }
      } catch (error) {
        this.stepChanging = false
        changeGoodsItem.disabled = false
        toastLoading.clear()
        console.log(error)
      }
    },
    // 订单结算
    async onSettlement() {
      try {
        const sendGoodsArr =
          this.getAllChooseGoods().map((item) => ({
            Id: item.GoodSkuId,
            Count: item.Count
          })) || []
        const confirmGoods = this.getAllChooseGoods() || []
        // 模拟假数据
        if (!sendGoodsArr.length) {
          this.$toast({
            position: 'bottom',
            message: '请选择需要支付的商品'
          })
          return
        }
        // 判断是否满足物流起送价
        if (this.totalAmount < this.LogisticsFee.StartingPrice) {
          this.$toast({
            position: 'bottom',
            message: '总价低于起购价不能下单'
          })
          return
        }

        this.$hys.openLoading()
        const ActivityLists = []
        // 组装活动数据
        // 只找活动商品
        this.goodsList.filter((val) => val.ActivityInfo.ActivityType == 1).forEach(val => {
          val.ActivityList.forEach(subVal => {
            // 只有满足条件的数据才放入Activitys
            // 如果有RuleText 那就满足规则了
            const Activity = subVal.Activity
            const ruleIndex = Activity.ruleIndex
            const tempAcData = {
              'ActivityId': Activity.ActivityId,
              'GoodIds': subVal.GoodsSkus.filter(goodsVal => goodsVal.checked).map(goodsVal => goodsVal.GoodSkuId)
            }
            // eslint-disable-next-line no-prototype-builtins
            if (Activity.RuleText && Activity.hasOwnProperty('ruleIndex') && ruleIndex !== -1) {
              // 满返是优惠券 其它都是商品类型数据
              if (val.ActivityInfo.ActivityCode === 7) {
                tempAcData.FreebieIds = Activity.Rules[ruleIndex].CouponList.map(coupon => coupon.CouponId)
                ActivityLists.push(tempAcData)
              } else if (val.ActivityInfo.ActivityCode === 4) {
                tempAcData.FreebieIds = Activity.Rules[ruleIndex].ProductList.filter(ProductList => ProductList.checked ?? false).map(ProductList => ProductList.GoodSkuId)
                tempAcData.FreebieIds.length ? ActivityLists.push(tempAcData) : null
              } else {
                tempAcData.FreebieIds = Activity.Rules[ruleIndex].ProductList.map(ProductList => ProductList.GoodSkuId)
                ActivityLists.push(tempAcData)
              }
              // eslint-disable-next-line no-prototype-builtins
            } else if (Activity.RuleText && !Activity.hasOwnProperty('ruleIndex')) {
              ActivityLists.push(tempAcData)
            }
          })
        })

        const sendTotalAmount = Number(this.totalAmount.toFixed(4))
        const formData = {
          OrderAmountActualSum: sendTotalAmount,
          Commoditys: sendGoodsArr // 所有选中的商品
        }
        if (ActivityLists.length) {
          formData.ReadyActivitys = ActivityLists
        }

        // 提交

        const result = await this.postAction(this.url.confirmCarOrder, formData)
        if (!result.IsSuccess) {
          this.$hys.clearLoading()
          this.$toast({ position: 'bottom', message: result.Msg })
          return
        }
        // 判断库存
        let msg = ''
        const params = {
          preFormData: formData,
          goods: confirmGoods,
          order: result.Data,
          Id: result.Data.CustomerReceivingAddress.Id,
          OrderAmountActualSum: sendTotalAmount,
          FreebieAmount: result.Data.FreebieAmount
        }
        if (result.Data.Code == 100010) {
          result.Data.Activitys.forEach(v => {
            let tempsString = v.ActivityName + '活动,'
            v.Freebies.forEach(vvv => {
              tempsString += vvv.GoodsType == 3 ? '礼样品' : '换购品'
              tempsString += `${vvv.Name}不足`
            })
            v.Freebies.length ? msg += tempsString : null
          })
          Dialog.confirm({
            title: '提示',
            message: msg,
            confirmButtonText: '继续',
            cancelButtonText: '取消'
          })
            .then(() => {
              this.$hys.clearLoading()
              this.$router.push({
                name: LinkTypeCode.ConfirmOrder,
                params
              })
            }).catch(() => {
              this.$router.push({
                name: LinkTypeCode.BuyCar,
                params
              })
            })
        } else {
          this.$hys.clearLoading()
          this.$router.push({
            name: LinkTypeCode.ConfirmOrder,
            params
          })
        }
      } catch (error) {
        console.log(error)
        this.$hys.clearLoading()
      }
    }

  }
}
</script>

<style scoped lang="less">
@import url('./src/styles/BuyCar.less');

/deep/.notify_class {
  /deep/.el-message-box__message p {
    color: red;
  }
}

.itm {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  border: 1px solid #EBEEF2;
  border-radius: 2px;
  width: 100%;
  height: 56px;
  background: #F0F3F5;
  flex-direction: row;

  .check {
    display: flex;
    align-items: center;
    margin-left: 20px;
  }

  .content {
    display: flex;
    justify-content: space-between;
    margin-left: 40px;
    width: 1120px;
    color: #FFFFFF;

    .type-title {
      margin-right: 12px;
      border-radius: 4px;
      width: 56px;
      height: 24px;
      font-size: 16px;
      font-weight: 500;
      text-align: center;
      background: linear-gradient(157deg, #FF6506 0%, #FF3939 100%);
      line-height: 24px;
    }

    .type-cut {
      font-size: 16px;
      font-weight: 500;
      color: rgba(17, 26, 52, 1);
    }

    .type-next-reward {
      color: #111A34;
    }

    .left-content {
      display: flex;
    }

    .right-content {
      margin-right: 33px;
      font-size: 14px;
      color: rgba(255, 57, 57, 1);

      &:hover {
        cursor: pointer;
      }
    }
  }
}

.no-margin-top {
  margin-top: 0;
}
</style>
